import csv from "csvtojson"

export function getParameterByName(name, url) {

    name = name.replace(/[\[\]]/g, "\\$&")
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ""
    return decodeURIComponent(results[2].replace(/\+/g, " "))
}

export function humanFileSize(bytes: number): string {

    const base: number = 1000

    if (Math.abs(bytes) < base) {
        return bytes + " B"
    }
    const units = ["kB", "MB", "GB", "TB", "PB"]
    let u = -1
    do {
        bytes /= base
        ++u
    } while (Math.abs(bytes) >= base && u < units.length - 1)
    return bytes.toFixed(1) + " " + units[u]
}

export const readFile = (file, withHeaders = true) =>
    new Promise(function (res, rej) {
        const reader = new FileReader()
        reader.onload = (e) => {
            // @ts-ignore
            csv({delimiter: ","}).fromString(reader.result)
                .then(result => {
                    res(result)
                })
        }

        reader.readAsText(file)
    })


export function toDateTime({val, showTime}: { val: Date, showTime?: boolean }) {

    if (!val)
        return "-"

    const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric"
    }

    if (showTime) {
        options.hour = "2-digit"
        options.minute = "2-digit"
        options.hour12 = true
    }

    return (new Date(val)).toLocaleDateString("en-US", options)
}